import {
    Component,
    DestroyRef,
    inject,
    OnInit
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import {
    debounceTime,
    distinctUntilChanged,
    finalize,
    forkJoin,
    from,
    map,
    Observable,
    startWith,
    switchMap,
    tap,
    timer
} from 'rxjs';
import { appurl, onepageioBaseUrl } from '../../../../environments/environment';
import {
    MentorConnectedUser,
    TtoLeadsFromDb,
} from '../../../interfaces/responsedata.ts/mentor';
import { Userdata } from '../../../interfaces/userdata';
import { ClipboardService } from '../../../service/clipboard.service';
import { MentorService } from '../../../service/mentor.service';
import { UserdataService } from '../../../service/userdata.service';

const POLLING_INTERVAL_IN_MINUTES = 5;

enum ColorStates {
    success = 'success',
    error = 'error',
    warning = 'warning',
    nutral = 'nutral',
}

enum TrendingStates {
    positiv = 'trending-up',
    negativ = 'trending-down',
    nutral = 'arrow-right',
}

@Component({
    selector: 'app-startup-navigator',
    standalone: false,
    templateUrl: './startup-navigator.component.html',
    styleUrl: './startup-navigator.component.scss',
})
export class StartupNavigatorComponent implements OnInit {
    // Injections
    private user = inject(UserdataService);
    protected mentorService = inject(MentorService);
    private clipboardService = inject(ClipboardService);
    private destroyRef = inject(DestroyRef);

    // Objects
    userData: Userdata | undefined;
    newInvitees: TtoLeadsFromDb[] = [];
    mentorUsers: MentorConnectedUser[] = [];

    // Variables
    loadingData: boolean = false;
    isLoading: boolean = false;
    userPrename: string = '';
    licenseData: any = undefined;
    registrationTrending: ColorStates = ColorStates.nutral;
    registrationTrendingIcon: TrendingStates = TrendingStates.nutral;
    registrationTrendingPercentage: number = 0;

    totalstreamsTrending: ColorStates = ColorStates.nutral;
    totalstreamsTrendingIcon: TrendingStates = TrendingStates.nutral;
    totalstreamsTrendingPercetage: number = 0;
    totalStreams: number = 0;
    totalStreamsLastMonth: number = 0;
    totalStreamThisMonth: number = 0;

    licenseTrending: ColorStates = ColorStates.warning;

    protected searchQuery = new FormControl({ value: '', disabled: true });
    protected invitationLinks: string[] = [];

    async ngOnInit(): Promise<void> {
        this.userPrename = this.user.getUserDataByKey('prename')!;
        this.licenseData = this.user.getUserDataByKey('licenseData');

        this.onSearchChange();

        await this.getMentorInvitationLinks();
    }

    protected async acceptedUserInvite(leadId: string): Promise<void> {
        const mentorUsers =
            await this.mentorService.getAllConnectedUserByMentorId();

        if (mentorUsers === false) {
            return;
        }

        this.mentorUsers = mentorUsers.totalData;
        this.licenseData[0].freeSeats = mentorUsers.updatedLicense[0].freeSeats
        this.licenseData[0].totalSeats = mentorUsers.updatedLicense[0].totalSeats
        this.removeInviteeFromLocalList(leadId);
    }

    protected removeInviteeFromLocalList(leadId: string): void {
        this.newInvitees = this.newInvitees.filter(
            (invitee) => invitee.id !== leadId,
        );
    }

    protected removeFounderFromLocalList(founderId: string): void {
        this.mentorUsers = this.mentorUsers.filter(
            (mentorUser) => mentorUser.id !== founderId,
        );

        this.licenseData[0].freeSeats += 1;
    }

    protected async calculateAcceptedRegistrations() {
        // calculate percentage
        this.totalStreams = 0;
        this.totalStreamsLastMonth = 0;
        this.totalStreamThisMonth = 0;
        this.totalstreamsTrendingPercetage = 0;
        this.totalstreamsTrending = ColorStates.nutral;
        this.totalstreamsTrendingIcon = TrendingStates.nutral;

        for (const user of this.mentorUsers) {
            this.totalStreams += user.streamsTotal || 0;
            this.totalStreamsLastMonth += user.streamsLastMonth || 0;
            this.totalStreamThisMonth += user.streamsCurrentMonth || 0;
        }

        this.totalstreamsTrendingPercetage =
            this.totalStreamsLastMonth > 0
                ? ((this.totalStreams - this.totalStreamsLastMonth) /
                    this.totalStreamsLastMonth) *
                100
                : 0;

        if (this.totalstreamsTrendingPercetage > 0) {
            this.totalstreamsTrending = ColorStates.success;
            this.totalstreamsTrendingIcon = TrendingStates.positiv;
        } else if (this.totalstreamsTrendingPercetage < 0) {
            this.totalstreamsTrending = ColorStates.error;
            this.totalstreamsTrendingIcon = TrendingStates.negativ;
        }
    }

    protected copyLink(link: string, parameter: string): void {
        if (parameter === 'onepageio') {
            let oLink = link.split('inviteId=')[1];
            this.clipboardService.easyCopyToClipboard(
                `${onepageioBaseUrl}?cid=${oLink}`,
            );
        } else {
            this.clipboardService.easyCopyToClipboard(link);
        }
    }

    private pollMentorConnectionsData$(search?: string): Observable<void> {
        const periodInMs = POLLING_INTERVAL_IN_MINUTES * 60 * 1000;

        return timer(0, periodInMs).pipe(
            tap(() => (this.isLoading = true)),
            switchMap(() =>
                forkJoin([
                    from(this.mentorService.getNewInviteesByMentorId(search)),
                    from(this.mentorService.getAllConnectedUserByMentorId(search)),
                ]),
            ),
            map(([newInvitees, allConnectedUser]) => {
                this.isLoading = false;

                if (newInvitees === false || allConnectedUser === false) {
                    this.searchQuery.disable();

                    return;
                }

                this.newInvitees = newInvitees;
                this.mentorUsers = allConnectedUser.totalData;
                console.log("mentorUsers", this.mentorUsers)
                this.licenseData[0].freeSeats = allConnectedUser.updatedLicense[0].freeSeats
                this.licenseData[0].totalSeats = allConnectedUser.updatedLicense[0].totalSeats
                // console.log("LicU", this.licenseData.freeSeats, allConnectedUser.updatedLicense[0].freeSeats)

                if (!this.newInvitees.length && !this.mentorUsers.length) {
                    this.searchQuery.disable();
                } else {
                    this.searchQuery.enable();
                }
                this.calculateAcceptedRegistrations();
            }),
            finalize(() => (this.isLoading = false)),
        );
    }

    private onSearchChange(): void {
        this.searchQuery.valueChanges
            .pipe(
                startWith(this.searchQuery.value),
                debounceTime(500),
                distinctUntilChanged(),
                switchMap((value) => {
                    const searchString = value?.length ? value : undefined;

                    return this.pollMentorConnectionsData$(searchString);
                }),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe();
    }

    private async getMentorInvitationLinks(): Promise<void> {
        const mentorInvitationData =
            await this.mentorService.getMentorInvitationLinks();

        if (typeof mentorInvitationData === 'boolean') {
            this.invitationLinks = [];

            return;
        }

        this.invitationLinks = [];

        for (const invitationData of mentorInvitationData) {
            const invitationLink = `${appurl}/login/register?inviteId=${invitationData.id}`;

            this.invitationLinks.push(invitationLink);
        }
    }
}
